import { PRIVACY_EMAIL } from "@/lib/contact";

export const CURRENT_DATE = "May 26, 2026";

export const DATA_TYPES = [
  {
    tag: "Content",
    title: "Service Data",
    description:
      "Uploaded documents, client information, portfolio data, financial data from integrations, research queries, meeting notes, and custom configurations.",
  },
  {
    tag: "Account",
    title: "Account Information",
    description:
      "Email address, phone number, password, and billing details for account creation and management.",
  },
  {
    tag: "Behavior",
    title: "Usage Information",
    description:
      "Metadata about how you interact with the Services, including features used and research queries made.",
  },
  {
    tag: "Logs",
    title: "Log Data",
    description:
      "Server logs including IP address, browser type, settings, and timestamps retained for 365 days.",
  },
  {
    tag: "Device",
    title: "Device Information",
    description:
      "Device type, operating system, device settings, unique identifiers, and crash data.",
  },
  {
    tag: "Cookies",
    title: "Cookie Information",
    description:
      "Cookies and similar technologies used to collect information about your browsing activities.",
  },
] as const;

export const PRIVACY_USE_CASES = [
  "Provide, update, maintain and protect our Services",
  "Support research, analysis, and advisor work-product features",
  "Comply with applicable law and legal process",
  "Communicate with you about Services",
  "Develop and provide additional features",
  "Investigate and prevent security issues",
] as const;

export const GOOGLE_WORKSPACE_DATA_USE_PARAGRAPHS = [
  "Zom AI is a financial advisory intelligence platform for registered investment advisers and wealth-management teams. The app brings client context, documents, communications, calendars, portfolio data, and workflow history into one advisor-controlled workspace so teams can research, prepare, follow up, and supervise advisory work more efficiently.",
  "When a customer connects Google Workspace, Zom requests access only to support the advisory workflows that customer enables. Zom uses that data to retrieve relevant context, generate advisor-reviewed work product, maintain auditability, and help the firm complete client-service tasks inside Zom.",
] as const;

export const GOOGLE_WORKSPACE_DATA_TYPES = [
  "Gmail: Zom reads advisor-authorized email metadata and message content to help prepare client follow-ups, surface prior conversations, and draft compliant communications for advisor review.",
  "Google Calendar: Zom uses authorized calendar event details to understand upcoming meetings, prepare agendas, and connect meeting activity to the right household or advisory workflow.",
  "Google Drive: Zom accesses authorized Drive content to find approved client documents, investment policy statements, meeting notes, and other materials advisors ask Zom to use.",
] as const;

export const GOOGLE_WORKSPACE_DATA_GUARDRAILS = [
  "Google Workspace connections are optional and controlled by each customer.",
  "Connected Google user data is used only to provide requested Zom product workflows.",
  "Connected Google user data is not sold, used for advertising, or used to train AI models.",
  `Access can be disconnected by the customer, and privacy requests can be sent to ${PRIVACY_EMAIL}.`,
] as const;

export const PRIVACY_RETENTION_STATS = [
  {
    value: "Until requested",
    label:
      "Documents retained until a deletion request is submitted in Settings",
  },
  {
    value: "365",
    label: "Days application log data retained",
  },
  {
    value: "3",
    label: "Years applicant data retained",
  },
] as const;
